import React from "react";
import cx from "classnames";
import {useTranslation} from "react-i18next";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { ExpandMore as ExpandMoreIcon } from '@vedmarket/ui-kit';
import Divider from "@mui/material/Divider";
import { Check as CheckIcon } from '@vedmarket/ui-kit';
import {numberWithSpaces} from "../../../../../../../utils/helpers";

import CodeServices from "./components/code-services";

import {COLORS} from "../../../../../../../config/constants";

import './company-card.scss'

type Props = {
    isActive?: boolean;
    company: BrokerCompany;
    handleChoose?(id: number): void;
}

const CompanyCard = ({ isActive, company, handleChoose } : Props ) => {

  const { t } = useTranslation()

  const name = company?.company?.name || company?.broker?.name;

  const handleSave = () => {
    if (handleChoose) {
      handleChoose(company.tariff_id);
    }
  }

  return <Card className={cx('company-card-broker', {
    'company-card-broker_active': isActive,
  })} sx={{ background: isActive ? COLORS.LIME : COLORS.WHITE, borderRadius: 0, boxShadow: 'none' }}>
    <CardContent sx={{
      padding: 0, '&:last-child': {
        paddingBottom: 0
      }
    }}>
      <div className={cx('company-card-broker__main-content', {
        'company-card-broker__main-content_active': isActive,
      })}>
        <div className='company-card-broker__left'>
          <span className='company-card-broker__logo'>{name?.[0]}</span>
          <Typography variant='subtitle2'>
            {name}
          </Typography>
        </div>
        <div className={cx('company-card-broker__right', {
          'company-card-broker__right_active': isActive,
        })}>
          <Typography variant='h6' sx={{ lineHeight: 1.2, marginRight: 3 }}>
            {numberWithSpaces(company.cost_total.toFixed(2))} {company.currency}
            <span className='company-card-broker__subtitle'>{t('calc__text__customs__forTheDeclaration')}</span>
          </Typography>
          <Button
            variant='outlined'
            fullWidth
            onClick={handleSave}
            sx={{
              width: isActive ? 145 : 155,
              '&.Mui-disabled': {
                backgroundColor: COLORS.SLIGHTLY_GRAY,
                color: COLORS.LIGHT_TEXT_DISABLED_OPACITY,
                border: 'none'
              }
            }}
            disabled={isActive}
          >{isActive ? t('common__text__selected') : t('actions__text__choose')}</Button>
        </div>
      </div>
      <Divider/>
      <CodeServices isActive={isActive} services={company.services}/>
    </CardContent>
  </Card>
}

export default CompanyCard
